// Asset Model name construction for Smart Asset Import.
//
// AssetPro auto-creates the Asset Model from:  Make + Asset Sub Type + Model No (optional).
// e.g. Make "Jakson Limited" + Sub Type "400 KVA" + (no Model No)  ->  "Jakson Limited 400 KVA".
// The Model No is optional and simply appended when present.
//
// This is a deterministic concatenation of values that already exist on the row — it does not
// invent data. When Make and Sub Type are both empty it returns '' (the upstream required-field
// checks on Make / Sub Type surface that as a problem).

const clean = (v) => (v === null || v === undefined ? '' : String(v).replace(/\s+/g, ' ').trim());

/**
 * Build the Asset Model name: Make + Asset Sub Type + Model No (optional).
 * @param {*} make
 * @param {*} subType
 * @param {*} modelNo  optional
 * @returns {string}
 */
export const buildAssetModelName = (make, subType, modelNo) => {
  const base = [clean(make), clean(subType)].filter(Boolean).join(' ');
  const mn = clean(modelNo);
  if (!mn) return base;
  return base ? `${base} ${mn}` : mn;
};
